import React from 'react';

import { Typography } from '@gogame/components';

export default ({ data }) => {
  return {
    color: 'warning',
    date: data.playerInformation.fraudDateTime,
    title: <Typography>Fraud - {data.playerInformation.fraudType}</Typography>,
    content: null,
  };
};
